<template>
  <div class="page-module-wrap">
    <div class="section-gap">
      <div class="block clearfix">
        <div class="control fleft search-component">
           <label for="search">ICON名称</label>：
            <el-select v-model="selectedBlogger" filterable placeholder="请选择">
              <el-option
                v-for="item in bloggers"
                :key="item.bloggerId"
                :label="item.name"
                :value="item.bloggerId">
              </el-option>
            </el-select>
           <button class='button is-primary' @click="searchIcon">搜索</button>
           <button class="button is-info" style="margin-left: 20px;" @click="clear">清空</button>
        </div>
        <div class="control fright">
          <router-link class="button is-primary" :to="{name: 'editIconCategory'}">编辑分类</router-link>
          <button class="button is-primary" @click="addCategory">添加分类</button>
        </div>
      </div>
    </div>

    <div class="tabs is-toggl">
      <ul class="">
        <li v-for="(item,index) in categoryList" :class="{ 'is-active': activeIndex == index }" v-on:click="onTabClick(item.categoryId, index)">
            <a><span>{{ item.categoryName }} </span></a>
        </li>
      </ul>
    </div>
    <div class="list-wrap">
      <div class="clearfix">
        <div class="fleft">
          <router-link class="button is-success" :to="{ name: 'editIcon'}">新增</router-link>
        </div>
        <el-pagination
          v-if="count > 0"
          @current-change="handleCurrentChange"
          :current-page="search.page"
          :page-size="search.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <table class="table is-bordered">
            <thead>
              <tr>
                <th>ID</th>
                <th>ICON名称</th>
                <th>短介绍</th>
                <th>待放行/已放行/内容数量</th>
                <th>排序号</th>
                <th>创建时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in list">
                <td>{{item.bloggerId}}</td>
                <td>
                  {{item.name}}<br/>
                  <button class='button is-warning' v-if="item.isClose">已关闭</button>
                </td>
                <td>{{item.brief}}</td>
                <td>{{item.waitVerifiedCount}}/{{ item.verifiedCount }}/{{item.contentCount}}</td>
                <td>
                  <input type="number" class="input width-1" v-model="item.sort" @change="onSort(item.bloggerId, item.sort)">
                </td>
                <td>{{item.createTime}}</td>
                <td>
                  <button class="button is-primary" @click="goEdit(item)">编辑</button>
                  <button class="button is-info" @click="goSource(item,1)">配置内容源</button>
                  <router-link class="button is-success" :to="{name: 'articleList', query: {bloggerId: item.bloggerId}}">动态</router-link>
                  <button class="button is-info" @click="goSource(item,2)">配置商品源</button>
                </td>
              </tr>
            </tbody>
          </table>
        </article>
      </div>
      <div v-if="count > 0" class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="search.page"
          :page-size="search.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="添加分类" :visible.sync="modal.visible">
      <div class="margin-left margin-top">
          <p class="margin-top">
            <span class="radio r-top">
              <label for="storage">分类名称:</label>
              <input class="block input width-3" v-model="modal.categoryName">
            </span>
          </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modal.visible = false">取 消</el-button>
        <el-button type="primary" @click="MODAL_OK_EVENT">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
  export default {
    props: {
      itemName: {
        type: String,
        default(){
          return '';
        }
      },
    },
    data(){
      return {
        categoryList: [],
        activeIndex: 0,
        categoryName: '',
        categoryId: '',
        list:[],
        count:0,
        search:{
          page:1,
          pageSize:20
        },
        modal: {
          visible: false,
          type: '',
          index: '',
          indexArr: [],
          businessUserId:'',
          categoryName: '',
        },
        bloggers: [],
        selectedBlogger: ""
      }
    },
    mounted(){
      if (this.$route.query.page) {
        this.search.page = this.$route.query.page*1;
        this.activeIndex = this.$route.query.activeIndex*1;
        this.categoryId = this.$route.query.categoryId*1;
      }
      if(this.$route.query.selectedBlogger){
        this.selectedBlogger = Object.assign(JSON.parse(this.$route.query.selectedBlogger));
      }
      this.getInitialCategory()
      this.getBloggers()
    },
    methods:{
      /**
       * 接收子组件Modal ok 点击事件
       * @constructor
       */
      MODAL_OK_EVENT() {
        let [url,params] = ['', null];
        this.doSaveCategory();
        this.modal.visible = false;
      },
      /**
       * 接收子组件pagination分页点击事件
       * @param  {[type]} value [description]
       * @return {[type]}       [description]
       */
      handleCurrentChange(value){
        if(this.search.page !== value){
          this.search.page = value;
          this.getList(this.search)
        }
      },
      onSort(bloggerId, sort) {
        let params = {
          bloggerId: bloggerId,
          sort: sort
        }
        HttpRequest.get('/admin.php?method=blogger.doSaveIconSort', params).then(response => {
          if (response.data.success) {
            this.$message('修改成功')
          }
        })
      },
      /**
       * 获取初始化数据列表；
       */
      getList(_params){
        let params = {
          categoryId: this.categoryId,
          page: _params.page,
          pageSize: _params.pageSize,
        }
        if (this.selectedBlogger) {
          params.bloggerId = this.selectedBlogger
        }
        HttpRequest.get('/admin.php?method=blogger.getIconList', params).then(response => {
          if (response) {
            this.list = _.toArray(response.data.list);
            this.count = response.data.count;
          }
        })
      },
      /**
       * 获取初始分类列表；
       */
      getInitialCategory() {
        HttpRequest.get('/admin.php?method=blogger.getIconCategoryList').then(response => {
          this.categoryList = response.data;
          if ( this.$route.query.categoryId ) {
            this.categoryId = this.$route.query.categoryId*1;
          } else {
            this.categoryId = response.data[0].categoryId;
          }
          this.getList(this.search);
        })
      },
      getBloggers() {
        HttpRequest.get('/admin.php?method=fashion.getBloggers').then(response => {
          this.bloggers = response.data;
          this.bloggers.unshift({
            bloggerId:'',
            name:"全部"
          })

        })
      },
      /**
       * 添加分类；
       */
      doSaveCategory() {
        let params = {
          categoryName: this.modal.categoryName,
        }
        HttpRequest.get('/admin.php?method=blogger.doSaveIconCategory', params).then(response => {
          if (response.data.success === 1) {
            this.getInitialCategory();
          }
        })
      },
      updateSelectedSearch(value) {
        this.selectedBlogger = value
      },
      searchIcon() {
        this.getList({ page: 1, pageSize: 20 })
      },
      onTabClick(item, index) {
        this.search.page = 1;
        this.activeIndex = index;
        this.categoryId = item;
        this.selectedBlogger = "";
        this.getList({ page: 1, pageSize: 20 })
      },
      addCategory() {
        this.modal.visible = true;
      },
      goEdit(item) {
        this.$router.push({
          name: 'editIcon',
          query: {
            bloggerId: item.bloggerId,
            page: this.search.page,
            selectedBlogger: this.selectedBlogger,
            activeIndex: this.activeIndex,
            categoryId: this.categoryId,
          }
        })
      },
      goSource(item,num) {
        if(num==1){
            this.$router.push({
                name: 'sourceManage',
                query: {
                    bloggerId: item.bloggerId,
                    page: this.search.page,
                    selectedBlogger: this.selectedBlogger,
                    activeIndex: this.activeIndex,
                    categoryId: this.categoryId,
                }
            })
        }else{
            this.$router.push({
                name: 'priorityProductSource',
                query: {
                    bloggerId: item.bloggerId,
                    page: this.search.page,
                    selectedBlogger: this.selectedBlogger,
                    activeIndex: this.activeIndex,
                    categoryId: this.categoryId,
                }
            })
        }
      },
      clear() {
        this.$router.push({
          name: 'cyzsIcon',
        })
        this.search.page = 1;
        this.selectedBlogger = "";
        this.activeIndex = 0;
      },
    }
  }
</script>
<style lang="less" scoped>
  .like-tabs {
    border-bottom: 1px solid #eee;
    margin-bottom: 30px;
  }
  .like-button {
    padding-left: 10px;
  }
  .likeTabItem{
    line-height: 60px;
    height: 50px;
    font-size: 16px;
    padding: 0 4px;
    box-sizing: border-box;

  }
  .likeTabItem :hover {
    color: #ae0fff
  }
  .active {
    border-bottom: 1px solid #337ab7;
  }
  .search-component {
    display: flex;

    label {
      margin: 5px 5px 0 0;
    }
    .button {
      margin-left: 5px;
    }
  }
</style>
